import './configuration-profile-view/configuration-profile-view.component';
import './configuration-profile-view/configuration-profile-view.scss';

import './configuration-profiles-table/configuration-profiles-table.component';
import './configuration-profiles-table/configuration-profiles-table.scss';

import './configuration-profiles-table-row/configuration-profiles-table-row.component';
import './configuration-profiles-table-row/configuration-profiles-table-row.scss';

import './configuration-profiles-view/configuration-profiles-view.component';
import './configuration-profiles-view/configuration-profiles-view.scss';

import './agent-configuration-profile-view/agent-configuration-profile-view.component'
import './agent-configuration-profile-view/agent-configuration-profile-view.scss'

import './agent-configuration-profile-select/agent-configuration-profile-select.component'
import './agent-configuration-profile-select/agent-configuration-profile-select.scss'

import './agent-configuration-profile-select-list/agent-configuration-profile-select-list'
import './agent-configuration-profile-select-list/agent-configuration-profile-select-list.scss'

import './agent-configuration-profile-link/agent-configuration-profile-link.component';
import './agent-configuration-profile-link/agent-configuration-profile-link.scss';

import './autonomous-agent-configuration-profile-view/autonomous-agent-configuration-profile-view.component';
import './autonomous-agent-configuration-profile-view/autonomous-agent-configuration-profile-view.scss';
